import React from 'react';
import PropTypes from 'prop-types';

import IconPDF from '../../../../components/IconPDF';
import IconZIP from '../../../../components/IconZIP';
import IconUniversal from '../../../../components/IconUniversal';
import IconSelectorTool from '../../../../components/IconSelectorTool';
import IconSoftware from '../../../../components/IconSoftware';
import IconFAQ from '../../../../components/iconFAQ';
import IconReplacementBattery from '../../../../components/IconReplacementBattery';

const switchIcon = linkIcon => {
    switch (linkIcon) {
        case 'PDF':
            return <IconPDF />;
        case 'ZIP':
            return <IconZIP />;
        case 'SELECTOR TOOL':
            return <IconSelectorTool />;
        case 'SOFTWARE':
            return <IconSoftware />;
        case 'FAQ':
            return <IconFAQ />;
        case 'REPLACEMENT BATTERY':
            return <IconReplacementBattery />;
        default:
            return <IconUniversal />;
    }
};

const IconSelector = ({ linkIcon }) => switchIcon(linkIcon);

IconSelector.propTypes = {
    linkIcon: PropTypes.string.isRequired,
};

export default IconSelector;
